import {
  Stitch,
  RemoteMongoClient,
  UserPasswordCredential,
  UserPasswordAuthProviderClient
} from 'mongodb-stitch-browser-sdk'

const APP_ID = 'atlas-pawgq'
const client = Stitch.hasAppClient(APP_ID)
  ? Stitch.getAppClient(APP_ID)
  : Stitch.initializeAppClient(APP_ID)

const db = client.getServiceClient(RemoteMongoClient.factory, 'mongodb-atlas').db('atlas')

function login (email, pass) {
  const credential = new UserPasswordCredential(email.trim().toLowerCase(), pass)
  return client.auth.loginWithCredential(credential)
}

function isLoggedIn () {
  // Check if there is currently a logged in user
  return client.auth.isLoggedIn
}

function getCurrentUser () {
  // Return the user object of the currently logged in user
  return client.auth.isLoggedIn ? client.auth.user : null
}

function logout () {
  // Logout the currently logged in user
  return client.auth.logout()
}

function sendResetPasswordEmail (email) {
  const emailPassClient = client.auth
    .getProviderClient(UserPasswordAuthProviderClient.factory)

  return emailPassClient.sendResetPasswordEmail(email.trim().toLowerCase())
}

function registerWithEmail (email, password) {
  const emailPasswordClient = client.auth
    .getProviderClient(UserPasswordAuthProviderClient.factory)

  return emailPasswordClient.registerWithEmail(email.trim().toLowerCase(), password)
}

export {
  client,
  db,
  getCurrentUser,
  isLoggedIn,
  login,
  logout,
  registerWithEmail,
  sendResetPasswordEmail
}
